/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Submit_Check_HintInputs */

const en_directory_submit_check_hint = /** @type {(inputs: Directory_Submit_Check_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paste your product URL and check it against the directory before continuing.`)
};

const zh_directory_submit_check_hint = /** @type {(inputs: Directory_Submit_Check_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`粘贴你的产品网址，先查询目录中是否已收录。`)
};

/**
* | output |
* | --- |
* | "Paste your product URL and check it against the directory before continuing." |
*
* @param {Directory_Submit_Check_HintInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_submit_check_hint = /** @type {((inputs?: Directory_Submit_Check_HintInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Submit_Check_HintInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_submit_check_hint(inputs)
	return zh_directory_submit_check_hint(inputs)
});
export { directory_submit_check_hint as "directory.submit.check.hint" }